export const LinkWidgetId = 'LinkWidget';

export enum LinkWidgetAttributes {
  TITLE = 'title',
  LINK = 'link',
  ACCESSIBILITY_TEXT = 'accessibilityText',
}
